import { langStore } from "@/stores/lang-store"
import DateFilterButton from "../buttons/date-filter-button"
import Flex from "../flex"
import DateInput from "../date-input"
import { periodStore } from "@/components/detail-modal/period-store"
import FilterIcon from "../icons/filter-icon"

const PeriodSettingDesktop = ({ bundle, onPeriodClick, onPeriodSearch }) => {
  const { lang } = langStore()
  const { startDate, endDate, setStartDate, setEndDate, active, setActive } = periodStore()

  return (
    <Flex className="items-center justify-between mb-1">
      <Flex className="items-center" gap={2}>
        <button
          className="flex items-center gap-2 px-2 py-1 rounded-md 
        bg-[rgba(2,32,71,0.05)]
        "
        >
          <FilterIcon />
          {bundle.filter.periodSettings[lang]}
        </button>
        <span className="w-px h-6 bg-[#e5e8eb] mx-px"></span>
        {bundle.dateFilters.map((item) => {
          const { key, label } = item
          return (
            <DateFilterButton
              key={key}
              isActive={active === key}
              onClick={() => onPeriodClick(key)}
            >
              {label[lang]}
            </DateFilterButton>
          )
        })}
      </Flex>

      <Flex className="items-center" gap={4}>
        <DateInput
          label={bundle.filter.startDate[lang]}
          value={startDate}
          onChange={(e) => {
            setActive(null)
            setStartDate(e.target.value)
          }}
        />
        <span className="font-bold px-0.5">~</span>
        <DateInput
          label={bundle.filter.endDate[lang]}
          value={endDate}
          onChange={(e) => {
            setActive(null)
            setEndDate(e.target.value)
          }}
        />
        <button
          onClick={onPeriodSearch}
          className="py-1.5 px-3 rounded-md bg-[rgba(0,27,55,0.1)] font-semibold cursor-pointer hover:bg-[rgba(0,27,55,0.2)]"
        >
          {bundle.search[lang]}
        </button>
      </Flex>
    </Flex>
  )
}

export default PeriodSettingDesktop
